export default __webpack_public_path__ + "static/media/icon_category-garden.f9468609.svg";